export function trimSnils(value: string): string {
  return value.replace(/\D/g, '')
}
